import { Component } from '@angular/core';

@Component({
  selector: 'allas-banner-principal-cotizar-por-whatsapp',
  imports: [],
  template: `
    <!-- Desktop Version -->
    <section
      class="hidden xl:grid grid-cols-12 bg-cover bg-center bg-no-repeat"
      style="background-image: url('/images/services/cotizar-por-whatsapp/cotiza-por-whatsapp.webp');"
    >
      <div
        class="flex flex-col gap-2 col-span-6 p-6 xl:p-12 justify-center items-center"
      >
        <main class="flex flex-col gap-2">
          <div
            class="flex flex-col xl:flex-row gap-0 xl:gap-2 items-start xl:items-center"
          >
            <span
              class="text-appBlack text-2xl xl:text-6xl 2xl:text-7xl font-extrabold fs-condensed"
            >
              COTIZA POR
              <span class="text-whatsappGreen">WHATSAPP</span>
            </span>
          </div>
          <p class="text-appBlack text-sm xl:text-2xl fs-condensed">
            ¿Necesitas un repuestos? Escríbenos por WhatsApp y obtén tu <br />
            cotización al instante. Fácil, rápido y sin complicaciones.
          </p>
          <div class="flex flex-col xl:flex-row gap-2 self-center mt-6">
            <a
              href="https://wa.me/50495089953?text=Hola,%20necesito%20cotizar%20un%20repuesto.%20¿Podrían%20ayudarme?"
              class="text-xs xl:text-base bg-whatsappGreen text-white px-4 py-2 rounded-md fs-condensed hover:scale-105 transition-all duration-300"
            >
              COTIZAR AHORA
            </a>
            <a
              href="tel:+50422834540"
              class="text-xs xl:text-base border-appBlack border text-appBlack px-4 py-2 rounded-md font-medium fs-condensed hover:scale-105 transition-all duration-300"
            >
              LLAMAR DIRECTAMENTE
            </a>
          </div>
        </main>
      </div>
    </section>

    <!-- Mobile Version -->
    <section
      class="xl:hidden grid grid-cols-12 bg-cover bg-center bg-no-repeat min-h-[60vh]"
      style="background-image: url('/images/services/cotizar-por-whatsapp/cotiza-por-whatsapp-mobile.webp'); background-size: cover;"
    >
      <div
        class="flex flex-col gap-4 col-span-12 p-6 justify-end items-center pb-[5px]"
      >
        <main class="flex flex-col gap-4 w-full text-center">
          <span class="text-appBlack text-3xl font-extrabold fs-condensed">
            COTIZA POR
            <span class="text-whatsappGreen">WHATSAPP</span>
          </span>
          <p class="text-appBlack text-sm fs-condensed">
            ¿Necesitas un repuestos? Escríbenos por WhatsApp y obtén tu
            cotización al instante. Fácil, rápido y sin complicaciones.
          </p>
          <div class="flex flex-col gap-3 self-center mt-2">
            <a
              href="https://wa.me/50495089953?text=Hola,%20necesito%20cotizar%20un%20repuesto.%20¿Podrían%20ayudarme?"
              class="bg-whatsappGreen text-white px-6 py-2 rounded-md fs-condensed hover:scale-105 transition-all duration-300 text-center text-sm"
            >
              COTIZAR AHORA
            </a>
            <a
              href="tel:+50422834540"
              class="border-appBlack border text-appBlack px-6 py-2 rounded-md font-medium fs-condensed hover:scale-105 transition-all duration-300 text-center text-sm"
            >
              LLAMAR DIRECTAMENTE
            </a>
          </div>
        </main>
      </div>
    </section>
  `,
})
export class BannerPrincipalCotizarPorWhatsapp {}
